import { Box, Button, Typography } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { useMemo } from "react";
import RequeridoLabel from "../../../../../commons/labels/RequeridoLabel";
import { tableConfig } from "../../../../../commons/table/tableConfig";

const ImportarNominasErrorTable = ({
    handleReintentar,
    data,
}) => {
    const isGeneralError = data.some(e => e.cuil === 'GENERAL');

    const columns = useMemo(() => [
        {
            accessorKey: "cuil",
            header: "CUIL",
            size: 140,
            Cell: ({ cell }) => cell.getValue() === 'GENERAL' ? '-' : cell.getValue(),
        },
        {
            accessorKey: "row",
            header: "Fila",
            size: 80,
            Cell: ({ cell }) => cell.getValue() || '-',
        },
        {
            accessorKey: "messages",
            header: "Error(es)",
            size: 500,
            Cell: ({ cell }) => (
                <ul style={{ margin: 0, paddingLeft: 16 }}>
                    {cell.getValue().map((msg, i) => (
                        <li key={i}>{msg}</li>
                    ))}
                </ul>
            ),
        },
    ], []);

    const table = useMaterialReactTable({
        columns,
        data: data || [],
        ...tableConfig,
        localization: MRT_Localization_ES,
        enableHiding: false,
        enableColumnActions: false,
        enableSorting: false,
        enablePagination: data.length > 10,
        initialState: {
            pagination: {
                pageSize: 10,
                pageIndex: 0,
            },
        },
        muiPaginationProps: {
            rowsPerPageOptions: [5, 10, 25],
            labelRowsPerPage: "Filas por página:",
            getItemAriaLabel: (type) => {
                if (type === "first") return "Ir a la primera página";
                if (type === "last") return "Ir a la última página";
                if (type === "next") return "Ir a la siguiente página";
                if (type === "previous") return "Ir a la página anterior";
                return "";
            },
            labelDisplayedRows: ({ from, to, count }) =>
                `${from}-${to} de ${count !== -1 ? count : to}`,
        },
        renderBottomToolbarCustomActions: () => (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    gap: 10,
                    padding: "10px 0",
                }}
            >
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleReintentar}
                >
                    Reintentar
                </Button>
            </div>
        ),
    });

    return (
        <div style={{ marginTop: 10 }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
                <Typography variant="h6">Errores de Importación</Typography>
            </div>

            <RequeridoLabel text={isGeneralError ? "Se detectó un problema de formato crítico." : "La importación arrojó los siguientes errores por CUIL, subsane los mismos y vuelva a intentar"} />

            <div style={{ marginTop: 10 }}>
                {isGeneralError ? (
                    <Box sx={{ p: 3, textAlign: 'center', border: '1px solid #ffcdd2', backgroundColor: '#ffebee', borderRadius: 1 }}>
                        <Typography color="error" variant="body1">
                            {data.find(e => e.cuil === 'GENERAL')?.messages[0]}
                        </Typography>
                    </Box>
                ) : (
                    <MaterialReactTable table={table} />
                )}
            </div>
        </div>
    );
};

export default ImportarNominasErrorTable;
